import DOMPurify from 'dompurify';
import * as Yup from 'yup';
import { API_BASE_URL } from "../config/config";
import axios from 'axios';
//import https from "https";

export const sanitizeInput = (value) => {
  return DOMPurify.sanitize(value);
};

// const httpsAgent = new https.Agent({
//     rejectUnauthorized: false
// });

export const xssSafeString = (message) => {
  return Yup.string()
    .trim()
    .required(message)
    .max(250, 'Must be 250 characters or less')
    .test('no-xss', 'Invalid characters detected', (value) => {
      const xssRegex = /(<script.*?>.*?<\/script>|javascript:|<.*?>|&.*?;|eval\(|alert\(|on[a-z]+\s*=\s*['"]?)/i;
      return !xssRegex.test(value || '');
    })
    .transform((value) => sanitizeInput(value));
};


export const getApiAccessToken = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/auth/get_token`, {});
    return response.data;
  } catch (error) {
    console.error('Error fetching token:', error);
  }
};

export const generateAuthToken = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/auth/update_token`, {});
    return response.data;
  } catch (error) {
    console.error('Error fetching token:', error);
  }
};

// Axios interceptor to handle token expiration
let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

const onRefreshed = (token) => {
  refreshSubscribers.map((cb) => cb(token));
  refreshSubscribers = [];
};

axios.interceptors.response.use(
  async (response) => {
    const { config, data } = response;
    
    // Check if the response indicates an expired token from the CRM API
    if (data && data.Message === "Expired token" && !config._retry) {
      console.log("Interceptor triggered: Expired token detected"); // Added log
      if (isRefreshing) {
        return new Promise((resolve) => {
          subscribeTokenRefresh((token) => {
            config.headers["Authorization"] = `Bearer ${token}`;
            resolve(axios(config));
          });
        });
      }

      config._retry = true;
      isRefreshing = true;

      try {
        const freshTokenRes = await generateAuthToken();
        const newToken = freshTokenRes.token;
        console.log("New token generated:", newToken); // Added log
        isRefreshing = false;
        onRefreshed(newToken);
        
        // Update the header for the retry
        config.headers["Authorization"] = `Bearer ${newToken}`;
        return axios(config);
      } catch (refreshError) {
        isRefreshing = false;
        refreshSubscribers = [];
        return Promise.reject(refreshError);
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

